import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class TblMaintenanceService {

  constructor(private http: HttpClient) { }

  // Load table list (action_code: c95czh)
  loadTableList(baseUrl: string, ssoId: string, owner: string = 'GTWDBA01'): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const params = {
      action_code: 'c95czh',
      sso_id: ssoId,
      owner: owner
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    const body = new URLSearchParams();
    Object.keys(params).forEach(key => {
      body.set(key, String(params[key as keyof typeof params]));
    });

    return this.http.post<any>(url, body.toString(), httpOptions);
  }

  // Load table column data (action_code: e7vrtt)
  loadTableColumnData(baseUrl: string, ssoId: string, srcTbl: string, arcTbl: string, owner: string = 'GTWDBA01'): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const params = {
      action_code: 'e7vrtt',
      sso_id: ssoId,
      owner: owner,
      src_tbl: srcTbl,
      arc_tbl: arcTbl
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    const body = new URLSearchParams();
    Object.keys(params).forEach(key => {
      body.set(key, String(params[key as keyof typeof params]));
    });

    return this.http.post<any>(url, body.toString(), httpOptions);
  }

  // Save table maintenance (action_code: wymcxb)
  saveTableMaintenance(
    baseUrl: string,
    jsonSettings: any[],
    jsonObj: any[],
    globalService: any,
    filterParams: any
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=wymcxb`;
    
    let params = _.merge({}, globalService.globalParams || {}, filterParams);
    
    // 🚀 CRITICAL: Add required fields with fallbacks
    params.tax_year = filterParams?.tax_year || globalService?.tax_year || '';
    params.scenario = filterParams?.scenario || globalService?.scenario || '';
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || '';
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenario_code || globalService?.scenarioCode || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || 'N';
    
    // Add jsonSettings and jsonObj as JSON strings
    params.jsonSettings = JSON.stringify(jsonSettings);
    params.jsonObj = JSON.stringify(jsonObj);
    
    // Add checkLockedbj (empty array with empty object)
    params.checkLockedbj = JSON.stringify([{}]);
    
    // Set process name
    params.process_name = 'INSERT_TBL_MAINTENANCE';

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    const body = new URLSearchParams();
    Object.keys(params).forEach(key => {
      const value = params[key as keyof typeof params];
      if (value !== null && value !== undefined) {
        body.set(key, String(value));
      }
    });

    return this.http.post<any>(url, body.toString(), httpOptions);
  }

  // Delete table maintenance records (action_code: wymcxb)
  deleteTableMaintenance(
    baseUrl: string,
    jsonObj: any[],
    jsonSettings: any[],
    globalService: any,
    filterParams: any
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=wymcxb`;
    
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    
    // 🚀 CRITICAL: Add required fields with fallbacks
    params.tax_year = filterParams?.tax_year || globalService?.tax_year || '';
    params.scenario = filterParams?.scenario || globalService?.scenario || '';
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || '';
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || globalService?.is_issue_key_enabled || 'N';
    
    // Add jsonSettings and jsonObj as JSON strings
    params.jsonSettings = JSON.stringify(jsonSettings);
    params.jsonObj = JSON.stringify(jsonObj);
    
    // Add checkLockedbj (empty array with empty object)
    params.checkLockedbj = JSON.stringify([{}]);
    
    // Set process name
    params.process_name = 'DELETE_TBL_MAINTENANCE';

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    const body = new URLSearchParams();
    Object.keys(params).forEach(key => {
      const value = params[key as keyof typeof params];
      if (value !== null && value !== undefined) {
        body.set(key, String(value));
      }
    });

    return this.http.post<any>(url, body.toString(), httpOptions);
  }
}

